import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';
import { DateTime } from 'luxon';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import {
    Paper, Typography, Button, Container,
    Dialog, DialogActions, DialogContent, DialogTitle,
    TableContainer, Table, TableHead, TableBody, TableRow, TableCell,
    FormControl, TextField, Box, Divider, Grid, Autocomplete
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import {
    DataGrid, GridCellParams, gridClasses,
    gridPageCountSelector,
    GridPagination,
    useGridApiContext,
    GridToolbar,
    useGridSelector,
} from '@mui/x-data-grid';
import MuiPagination from '@mui/material/Pagination';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomStatusChip from '../../utils/components/CustomStatusChip';
import CustomChip from '../../utils/components/CustomChip';
import useWindowDimensions from '../../utils/functions/useWindowDimensions';
import { formatMoney, getDate } from '../../utils/functions/Utils';
import LocaleTextDataGrid from '../../utils/functions/LocaleTextDataGrid';
import CustomLinearProgress from '../../utils/components/CustomLinearProgress';

const Seguimiento = () => {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [data, setData] = useState([]);
    const [selected, setSelected] = useState('');

    const [open, setOpen] = useState(false);
    const [currentReport, setCurrentReport] = useState(null);

    const [inicioManufactura, setInicioManufactura] = useState(DateTime.now());
    const [entregaEstimada, setEntregaEstimada] = useState(DateTime.now());
    const [seguimiento, setSeguimiento] = useState({});

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });
    const { height } = useWindowDimensions();

    const categories = ['3D Filamento', '3D Resina', '3D Resina y Filamento', 'Otros', ''];
    const prioridades = ['Azul', 'Verde', 'Amarillo', 'Rojo'];

    useEffect(() => {
        if (!['Admin', 'Vendedor', 'Ayudante'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Seguimiento';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    const getData = async () => {
        try {
            const res = await axios.get('/api/orders/seguimiento');
            if (res.status = 200) {
                if (res.data.length <= 1) {
                    res.data[0].fechaDeCotizacion = DateTime.fromISO(res.data[0].fechaDeCotizacion).toJSDate();
                    res.data[0].fechaDeEntrega = getDate(res.data[0].fechaDeEntrega);
                    res.data[0].seguimiento.inicioManufactura = DateTime.fromISO(res.data[0].seguimiento.inicioManufactura).toJSDate();
                    res.data[0].seguimiento.entregaEstimada = DateTime.fromISO(res.data[0].seguimiento.entregaEstimada).toJSDate();
                    if (res.data[0].cotizacion) {
                        res.data[0].monto = `$ ${formatMoney(res.data[0].cotizacion.total)}`
                    } else {
                        res.data[0].monto = `$ ${formatMoney(0)}`
                    }
                    setData(res.data);
                }
                else {
                    const tmp = res.data.map((item) => {
                        item.fechaDeCotizacion = DateTime.fromISO(item.fechaDeCotizacion).toJSDate();
                        item.fechaDeEntrega = getDate(item.fechaDeEntrega);
                        item.seguimiento.inicioManufactura = DateTime.fromISO(item.seguimiento.inicioManufactura).toJSDate();
                        item.seguimiento.entregaEstimada = DateTime.fromISO(item.seguimiento.entregaEstimada).toJSDate();
                        if (item.cotizacion) {
                            return { ...item, monto: `$ ${formatMoney(item.cotizacion.total)}` }
                        } else {
                            return { ...item, monto: `$ ${formatMoney(0)}` }
                        }
                    });
                    setData(tmp);
                }
                document.title = 'Seguimiento';
            }
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getData()
    }, [])

    const renderProducts = () => {
        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center' }}>
                    <Button size='small' variant='outlined' onClick={() => navigate('/cotizaciones')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
                    <Typography variant='h5' align='left' sx={{ mt: 1, mb: 1, fontWeight: 700, ml: 3 }}>Control de Manufactura</Typography>
                </div>
                <Box
                    sx={{
                        [`.${gridClasses.cell}.Verde`]: {
                            backgroundColor: '#66BB6A',
                            color: '#000',
                        },
                        [`.${gridClasses.cell}.Azul`]: {
                            backgroundColor: '#64B5F6',
                            color: '#000',
                        },
                        [`.${gridClasses.cell}.Amarillo`]: {
                            backgroundColor: '#EEFF41',
                            color: '#000',
                        },
                        [`.${gridClasses.cell}.Rojo`]: {
                            backgroundColor: '#B71C1C',
                            color: '#fff',
                        },
                    }}
                >
                    <DataGrid
                        autoPageSize={true}
                        sx={{ '& .MuiDataGrid-toolbarContainer': { position: 'fixed', top: '70px', right: '24px' }, '& .MuiButtonBase-root': { color: 'comp.gray' }, '& .MuiDataGrid-row': { backgroundColor: 'comp.tableBg', color: 'text.primary', height: 'auto' }, '& .MuiDataGrid-columnHeader': { backgroundColor: 'comp.tableHeaderBg', color: 'text.primary' } }}
                        style={{ height: `${height - 120}px`, width: '100%', overflow: 'hidden' }}
                        localeText={LocaleTextDataGrid}
                        rows={data}
                        density='compact'
                        getRowId={(row) => row._id}
                        onCellClick={(e) => { setSelected(e.row._id) }}
                        onCellDoubleClick={() => handleOpen()}
                        getCellClassName={(params) => {
                            if (params.field !== 'entregaEstimada') {
                                return '';
                            }
                            return params.row.seguimiento.prioridad
                        }}
                        columns={[
                            { field: 'noOrden', headerName: '#', flex: 1, minWidth: 60, maxWidth: 70, headerAlign: 'center', align: 'center' },
                            {
                                field: 'estatus',
                                flex: 1,
                                maxWidth: 160,
                                headerName: 'Estatus',
                                headerClassName: 'text-bold',
                                align: 'center',
                                headerAlign: 'center',
                                renderCell: (params) => (
                                    <CustomStatusChip estatus={params.row.estatus} label={params.row.estatus} />
                                ),
                            },
                            { field: 'descripcion', flex: 1, headerName: 'Descripción', align: 'center', headerAlign: 'center', minWidth: 200, valueGetter: (params) => params.row.seguimiento.descripcion },
                            { field: 'fechaDeCotizacion', flex: 1, type: 'date', headerName: 'Fecha de Cotización', align: 'center', headerAlign: 'center', maxWidth: 150 },
                            {
                                field: 'seguimiento.porcentajeAvance',
                                flex: 1,
                                maxWidth: 160,
                                headerName: '% avance',
                                headerClassName: 'text-bold',
                                align: 'center',
                                headerAlign: 'center',
                                renderCell: (params) => (
                                    <CustomLinearProgress progress={params.row.seguimiento.porcentajeAvance} />
                                ),
                            },
                            { field: 'inicioManufactura', flex: 1, type: 'date', headerName: 'Inicio Manufactura', align: 'center', headerAlign: 'center', maxWidth: 150, valueGetter: (params) => params.row.seguimiento.inicioManufactura },
                            { field: 'entregaEstimada', flex: 1, type: 'date', headerName: 'Entrega', align: 'center', headerAlign: 'center', maxWidth: 150, valueGetter: (params) => params.row.seguimiento.entregaEstimada, },
                            {
                                field: 'categoria',
                                flex: 1,
                                headerName: 'Categoría',
                                align: 'center',
                                headerAlign: 'center',
                                maxWidth: 200,
                                renderCell: (params) => (
                                    <CustomStatusChip estatus={params.row.seguimiento.categoria} label={params.row.seguimiento.categoria} />
                                ),
                            },
                            { field: 'monto', flex: 1, headerName: 'Monto', align: 'center', headerAlign: 'center', maxWidth: 150, cellClassName: 'text-bold' },
                            { field: 'observaciones', flex: 1, headerName: 'Observaciones', align: 'center', headerAlign: 'center', minWidth: 160, valueGetter: (params) => params.row.seguimiento.observaciones },

                        ]}
                        pagination
                        slots={{
                            pagination: CustomPagination,
                            toolbar: GridToolbar
                        }}
                        initialState={{
                            ...data.initialState,
                            pagination: { paginationModel: { pageSize: 25 } },
                            columns: {
                                columnVisibilityModel: {
                                    vendedor: false,
                                    operacion: false,
                                },
                            }
                        }}
                    />
                </Box>
            </div>
        )
    }

    const getReportInfo = async () => {
        let res = await axios.get(`/api/orders/${selected}`);
        if (res.status === 200) {
            setCurrentReport(res.data);
            res.data.seguimiento.inicioManufactura ? setInicioManufactura(DateTime.fromISO(res.data.seguimiento.inicioManufactura)) : setInicioManufactura();
            res.data.seguimiento.entregaEstimada ? setEntregaEstimada(DateTime.fromISO(res.data.seguimiento.entregaEstimada)) : setEntregaEstimada();
            res.data.seguimiento ? setSeguimiento(res.data.seguimiento) : setSeguimiento({});
        }
    }

    const handleOpen = () => {
        setOpen(true);
        getReportInfo();
    }


    const handleClose = () => {
        setOpen(false);
        setCurrentReport(null);
        setSeguimiento({});
    }

    const handleUpdate = async () => {
        try {
            const tmp = currentReport;
            tmp.seguimiento.inicioManufactura = inicioManufactura;
            tmp.seguimiento.entregaEstimada = entregaEstimada;
            tmp.seguimiento.categoria = seguimiento.categoria;
            tmp.seguimiento.observaciones = seguimiento.observaciones;
            tmp.seguimiento.descripcion = seguimiento.descripcion;
            tmp.seguimiento.rutaArchivo = seguimiento.rutaArchivo;
            tmp.seguimiento.flexEntrega = seguimiento.flexEntrega;
            tmp.seguimiento.prioridad = seguimiento.prioridad;

            let res = await axios.post(`/api/orders/${selected}`, { order: currentReport });
            if (res.status === 200) {
                setApiRes({ show: true, message: 'Reporte actualizado', severity: 'success' });
                handleClose();
                setData([]);
                getData();
            }
        } catch (err) {
            console.log(err);
            setApiRes({ show: true, message: 'Error al actualizar el reporte', severity: 'error' });
        }
    }

    const renderSeguimientoDetails = () => {
        if (currentReport === null) return;
        return (
            <Dialog
                open={open}
                onClose={() => handleClose()}
                fullWidth
                maxWidth='xl'
            >
                <DialogTitle>Avance del reporte</DialogTitle>
                <DialogContent>
                    <Box sx={{ mb: 2 }}>
                        <Divider sx={{ my: 1 }} textAlign="left">
                            <CustomChip variant='outlined' estatus='ATENDIDO' label='Informacion' className='text-bold' />
                        </Divider>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <DatePicker
                                        label="Inicio de Manufactura"
                                        format="dd/MM/yyyy"
                                        value={inicioManufactura}
                                        onChange={(newValue) => setInicioManufactura(newValue)}
                                        slotProps={{ textField: { variant: 'outlined' } }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <DatePicker
                                        label="Entrega estimada"
                                        format="dd/MM/yyyy"
                                        value={entregaEstimada}
                                        onChange={(newValue) => setEntregaEstimada(newValue)}
                                        slotProps={{ textField: { variant: 'outlined' } }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={3}>
                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo={true}
                                        onInputChange={(event, newInputValue) => setSeguimiento({ ...seguimiento, prioridad: newInputValue })}
                                        inputValue={seguimiento.prioridad}
                                        aria-multiline='true'
                                        options={prioridades}
                                        renderInput={(params) => <TextField {...params} label='Prioridad' />}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={3}>
                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo={true}
                                        onInputChange={(event, newInputValue) => setSeguimiento({ ...seguimiento, categoria: newInputValue })}
                                        inputValue={seguimiento.categoria}
                                        aria-multiline='true'
                                        options={categories}
                                        renderInput={(params) => <TextField {...params} label='Categoría' />}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                    <TableContainer>
                        <Table size='small'>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: 'comp.tableHeaderBg' }}>
                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Imagen</TableCell>
                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cantidad Solicitada</TableCell>
                                    <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Avance</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {currentReport.productos.map((item, index) => (
                                    <TableRow key={index} hover>
                                        <TableCell align="center">{item.descripcion}</TableCell>
                                        <TableCell align="center">
                                            <LazyLoadImage src={item.imagen} alt={item.nombre} style={{ width: '100px', height: '100px', objectFit: 'contain' }} />
                                        </TableCell>
                                        <TableCell align="center">{item.cantidad}</TableCell>
                                        <TableCell align="center">
                                            <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                                <TextField
                                                    label="Avance"
                                                    variant="outlined"
                                                    value={item.avance || ""} // Muestra el valor actual o una cadena vacía si es undefined
                                                    onChange={(e) => handleInputChange(e, index)} // Maneja el cambio en tiempo real
                                                />
                                            </FormControl>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ my: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Descripción" variant="outlined" value={seguimiento.descripcion} onChange={(e) => setSeguimiento({ ...seguimiento, descripcion: e.target.value })} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Observaciones" variant="outlined" value={seguimiento.observaciones} onChange={(e) => setSeguimiento({ ...seguimiento, observaciones: e.target.value })} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} >
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Ruta del archivo" variant="outlined" value={seguimiento.rutaArchivo} onChange={(e) => setSeguimiento({ ...seguimiento, rutaArchivo: e.target.value })} />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                        <Button color='secondary' sx={{}} variant='contained' onClick={() => navigate(`/cotizaciones/cotizacion/${currentReport._id}`, { target: '_blank' })}>Ver Cotización &nbsp; <i className="fad fa-file-invoice-dollar"></i></Button>
                        <Button color='success' sx={{}} variant='contained' onClick={() => handleUpdate()}>Actualizar &nbsp; <i className="fad fa-times"></i></Button>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleClose()}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleInputChange = (e, index) => {
        const { value } = e.target;
        setCurrentReport((prevReport) => {
            const updatedProductos = [...prevReport.productos];
            updatedProductos[index] = { ...updatedProductos[index], avance: value }; // Actualiza solo el campo "avance"
            return { ...prevReport, productos: updatedProductos }; // Retorna el nuevo objeto actualizado
        });
    };

    return (
        <Container maxWidth='xxl' sx={{ width: '100%', overflow: 'hidden', margin: '0px', padding: '4px 4px !important' }}>
            <Paper>
                {renderProducts()}
                {renderSeguimientoDetails()}
                <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
            </Paper>
        </Container>
    );
}

function Pagination({ page, onPageChange, className }) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
        <MuiPagination
            color="primary"
            className={className}
            count={pageCount}
            page={page + 1}
            onChange={(event, newPage) => {
                onPageChange(event, newPage - 1);
            }}
        />
    );
}

function CustomPagination(props) {
    return <GridPagination ActionsComponent={Pagination} {...props} />;
}

export default Seguimiento;